import React, { useEffect, useState } from 'react'
import { DatePicker, Select, Table, Button, Space } from 'antd'
import dayjs from 'dayjs'
import axios from 'axios'
import {
  GetFeeApprovedList,
  GetStudentListForAttendance,
  StudentAttendanceNight,
  StudentAttendanceMorning,
} from '../../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'
import '../Masters/MasterCSS.css'

const { Option } = Select

export default function StudentDailyAttendance() {
  const storedBranchId = sessionStorage.getItem('selected_branch')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [date, setDate] = useState(dayjs()) // today's date
  const [shift, setShift] = useState('morning') // "morning" or "night"
  const [studentList, setStudentList] = useState([])
  const [loading, setLoading] = useState(false)

  // -----------------------------
  // Fetch attendance student list
  // -----------------------------
  const fetchStudents = async () => {
    if (!shift) {
      toast.warning('Please select shift.')
      return
    }

    setLoading(true)

    try {
      const res = await axios.get(
        `${GetStudentListForAttendance}/${storedBranchId}/${BoardingYear}`,
      )

      const selectedDate = dayjs(date).format('YYYY-MM-DD')

      const formatted = res.data.map((item) => {
        let statusflag = '0'
        let disabledRow = false

        const selectedDate = dayjs(date).format('YYYY-MM-DD')

        // Find attendance for the selected date
        const todayAttendance = item.attendances?.find(
          (a) => a.date === selectedDate,
        )

        if (todayAttendance) {
          const morning = todayAttendance.morning_status
          const night = todayAttendance.night_status

          // Auto fill status
          if (shift === 'morning') {
            statusflag = morning?.toString() || '0'
          } else if (shift === 'night') {
            statusflag = night?.toString() || '0'
          }

           // ✔ SHIFT-BASED DISABLE LOGIC
              if (shift === "morning") {
                disabledRow = morning === 1 || morning === 2;
              }

              if (shift === "night") {
                disabledRow = night === 1 || night === 2;
              }
        }

        return {
          reg_id: item.reg_id,
          full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
          room: item?.roombooking?.room?.room_no,
          bed: item?.roombooking?.bed?.bed_no,
          statusflag,
          disabledRow, 
        }
      })

      setStudentList(formatted)
    } catch (err) {
      console.error(err)
      toast.error('Failed to load student list.')
    }

    setLoading(false)
  }

  useEffect(() => {
    if (shift) fetchStudents()
  }, [date, shift])

  // -----------------------------
  // Update individual attendance
  // -----------------------------
  const updateStatus = (id, flag) => {
    setStudentList((prev) =>
      prev.map((s) => (s.reg_id === id ? { ...s, statusflag: flag } : s)),
    )
  }

  // -----------------------------
  // Save Attendance
  // -----------------------------
 const handleSave = async () => {
  const pending = studentList.some((s) => s.statusflag === '0')
  if (pending) {
    toast.error('Please mark all students before saving.')
    return
  }

  const payload = {
    branch_id: parseInt(storedBranchId),
    date: date.format('YYYY-MM-DD'),
    year: BoardingYear,
    attendanceList: studentList.map((s) => ({
      reg_id: parseInt(s.reg_id),
      morning_status: shift === 'morning' ? parseInt(s.statusflag) : 0,
      night_status: shift === 'night' ? parseInt(s.statusflag) : 0,
    })),
  }

  try {
    let url =
      shift === 'morning'
        ? StudentAttendanceMorning
        : StudentAttendanceNight

    const res = await axios.post(url, payload)

    if (
      res.data === 'MORNINGATTENDANCESAVED' ||
      res.data === 'NIGHTGATTENDANCESAVED'
    ) {
      toast.success('Attendance saved successfully!')
    }
  } catch (err) {
    console.error(err)
    toast.error('Failed to save attendance.')
  }
}


  // -----------------------------
  // Table Columns
  // -----------------------------
  const columns = [
    {
      title: 'Sr No',
      render: (_, __, index) => index + 1,
      width: 70,
    },
    { title: 'Name', dataIndex: 'full_name' },
    { title: 'Room No', dataIndex: 'room', width: 100 },
    { title: 'Bed No', dataIndex: 'bed', width: 100 },

    {
      title: 'Attendance',
      dataIndex: 'statusflag',
      align: 'center',
      render: (flag, record) => (
        <Space>
          <Button
            primary
            type={flag === '1' ? 'primary' : 'default'}
            onClick={() => updateStatus(record.reg_id, '1')}
          >
            P
          </Button>

          <Button
            danger
            type={flag === '2' ? 'primary' : 'default'}
            onClick={() => updateStatus(record.reg_id, '2')}
          >
            A
          </Button>
        </Space>
      ),
    },
  ]

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2 pb-3"></div>
        <div className="col-12 col-md-8 pb-3">
          <div className="header-row">
            <h2 className="page-title">Daily Student Attendance</h2>
          </div>

          {/* Filters */}
          <div className="d-flex gap-3 my-3" style={{ flexWrap: 'wrap' }}>
            <DatePicker
              value={date}
              format="DD-MM-YYYY"
              onChange={(d) => setDate(d)}
              disabledDate={(d) => d > dayjs()} // disable future dates
            />

            <Select
              value={shift}
              onChange={(value) => {
                setShift(value)
                fetchStudents()
              }}
              style={{ width: 200 }}
            >
              <Option value="morning">Morning</Option>
              <Option value="night">Night</Option>
            </Select>
          </div>

          {/* Table */}
          <Table
            columns={columns}
            dataSource={studentList}
            rowKey="student_id"
            loading={loading}
            pagination={{ pageSize: 10 }}
            bordered
            scroll={{ x: 'max-content' }}
            rowClassName={(record) =>
              record.disabledRow ? 'locked-attendance-row' : ''
            }
          />

          <div className="text-center mt-3">
            <Button type="primary" onClick={handleSave}>
              Save Attendance
            </Button>
          </div>
        </div>
        <div className="col-12 col-md-2 pb-3"></div>
      </div>
    </div>
  )
}
